<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="500px"
    @close="$router.replace('/lists')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="country"
      :rules="rules"
      ref="countryForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="name"
        label="Név"
        :error="errors.name ? errors.name[0] : null"
      >
        <el-input v-model="country.name"/>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/lists')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    props: ['type', 'countryId'],
    data() {
      return {
        loading: false,
        errors: {
          name: null,
        },
        buttonLoading: false,
        country: {},
        rules: {
          name :[
            { required: true, message: 'Név megadása kötelező', trigger: 'blur' }
          ]
        }
      }
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új Ország';
        } else if (this.type === 'update') {
          return 'Ország módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadás';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },

    methods: {
      async add() {
        this.$refs['countryForm'].validate(async valid => {
          if(valid) {
            this.buttonLoading = true;
            this.errors.name = null;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('country/add', this.country);
              } else if (this.type === 'update') {
                await this.$store.dispatch('country/update', this.country);
              }
              this.$store.dispatch('country/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/lists');
            } catch (e) {
              if (e.data && e.data.errors) {
                this.errors = e.data.errors;
              }
            }
            this.buttonLoading = false;
          }
        });
      }
    },

    async mounted() {
      this.loading = true;
      if(this.countryId) {
        this.country = await this.$store.dispatch('country/fetch', this.countryId);
      }
      this.loading = false;
    }
  }
</script>
